import { DateUtil } from '@dto/util/DateUtil';
import type { RangePickerProps } from 'antd/es/date-picker';

type ValueDate = NonNullable<RangePickerProps['presets']>[number];

const now = () => DateUtil.now();

/** Read in the user's timezone, so `startOf('day')` is midnight there, not in the browser */
export const RANGE_PICKER_PRESETS = {
  lastHour: { label: 'Last Hour', value: () => [now().subtract(1, 'hour'), now()] },
  last24h: { label: 'Last 24h', value: () => [now().subtract(1, 'day'), now()] },
  lastDay: {
    label: 'Last Day', value: () => [
      now().subtract(1, 'day').startOf('day'),
      now().subtract(1, 'day').endOf('day'),
    ]
  },
  lastWeek: {
    label: 'Last Week', value: () => [
      now().subtract(1, 'week').startOf('day'),
      now().endOf('day'),
    ]
  },
  lastMonth: {
    label: 'Last Month', value: () => [
      now().subtract(1, 'month').startOf('day'),
      now().endOf('day'),
    ]
  },
  last3Months: {
    label: 'Last 3 Months', value: () => [
      now().subtract(3, 'months').startOf('day'),
      now().endOf('day'),
    ]
  },
  last6Months: {
    label: 'Last 6 Months', value: () => [
      now().subtract(6, 'months').startOf('day'),
      now().endOf('day'),
    ]
  },
  lastYear: {
    label: 'Last Year', value: () => [
      now().subtract(1, 'year').startOf('day'),
      now().endOf('day'),
    ]
  },
} as const satisfies Record<string, ValueDate>;

export const RANGE_DATE_PICKER_DEFAULT_PRESETS: NonNullable<RangePickerProps['presets']> = [
  RANGE_PICKER_PRESETS.lastHour,
  RANGE_PICKER_PRESETS.last24h,
  RANGE_PICKER_PRESETS.lastWeek,
  RANGE_PICKER_PRESETS.lastMonth,
  RANGE_PICKER_PRESETS.lastYear,
];

export const RANGE_DATE_PICKER_EXPORT_REPORT_PRESETS: NonNullable<RangePickerProps['presets']> = [
  RANGE_PICKER_PRESETS.lastHour,
  RANGE_PICKER_PRESETS.lastDay,
  RANGE_PICKER_PRESETS.lastWeek,
  RANGE_PICKER_PRESETS.lastMonth,
  RANGE_PICKER_PRESETS.lastYear,
];
